export default [
	{
		path: '/products',
		name: 'products',
		meta: {
			requiresAuth: true,
			section: 'products',
		},
		component: () => import('@/views/products/Products'),
	},
	{
		path: '/products/create',
		name: 'ProductCreate',
		meta: {
			requiresAuth: true,
			section: 'products',
		},
		component: () => import('@/views/products/ProductForm'),
	},
	{
		path: '/products/:id',
		name: 'ProductUpdate',
		meta: {
			requiresAuth: true,
			section: 'products',
		},
		component: () => import('@/views/products/ProductForm'),
	},
]
